module.exports = __webpack_public_path__ + "img/courier-fedex.85a80f0b.svg";